import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { environment } from "../../../../../src/environments/environment"
import { AuthservicesService } from 'src/app/services/authservices.service';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  form: FormGroup;
  error: string;
  id;
  loading = false;
  record: any;
  submitted = false;
  errorMessage
  constructor(
    public fb: FormBuilder, public router: Router, private authenticationService: AuthservicesService) { }

  ngOnInit(): void {

    this.errorMessage = environment.errorMessage
    this.record = JSON.parse(localStorage.getItem('requestToken'));
    this.form = this.fb.group({
      otp: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
    this.form.reset();
  }
  get f() { return this.form.controls; }



  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    if (this.form.valid) {
      let otp = this.form.get('otp').value
      let password = this.form.get('password').value
      let obj = { otp: otp, password: password, email: this.record.email, requestToken: this.record.requestToken, role: "Community" }
      console.log(obj)
      this.authenticationService.changePassword(obj).subscribe(
        (response: any) => {
          this.router.navigate(["/sign-in"]);
          this.authenticationService.successMessage(environment.changePassword, 'success')
        },
        error => {
          if (error) {
            this.authenticationService.successMessage(error.error.message, 'error')
          }
        }
      );
    }
  }
}
